export default new class cookiesComponent {
  constructor() {
    this.init();
  }

  // eslint-disable-next-line class-methods-use-this
  init() {
    $(window).on('load', () => {
      $('.preloader').delay(400).fadeOut('slow');
      if (localStorage.getItem('hide-cookie') !== 'hide') {
        $('.cookie-wrapper').delay(800).fadeIn('slow');
      }
    });

    $(document).on('click', '._cookie-close', () => {
      localStorage.setItem('hide-cookie', 'hide');
      $('.cookie-wrapper').delay(200).fadeOut('slow');
    });
  }
}();
